export const LOCAL_STORAGE_KEYS = {
    USER_KEY: process.env.REACT_APP_APP_USER_KEY || 'dms-user',
    ACCESS_TOKEN_KEY:
        process.env.REACT_APP_APP_ACCESS_TOKEN_KEY || 'dms-access-token',
    REFRESH_TOKEN_KEY:
        process.env.REACT_APP_APP_REFRESH_TOKEN_KEY || 'dms-refresh-token',
    USER_PERMISSION_KEY:"dms-user-permission",
};
